import {
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
  Skeleton,
  TableFooter,
  TablePagination,
  Button,
  Box,
} from '@mui/material';
import React from 'react';
import {useGetProvincesQuery} from 'api';
import AddIcon from '@mui/icons-material/Add';
import ProvinceDeleteIconButton from './ProvinceDeleteIconButton';
import ProvinceCreateModal from './ProvinceCreateModal';
import ProvinceEditIconButton from './ProvinceEditIconButton';
import {getImageURL} from '../../../utils/imageUrl';

const totalColumns = 4;

function ProvincesTable() {
  const {data, isLoading, isError, isSuccess} = useGetProvincesQuery();
  const [isOpen, setIsOpen] = React.useState(false);

  return (
    <>
      <ProvinceCreateModal
        open={isOpen}
        onClose={() => {
          setIsOpen(false);
        }}
      />
      <TableContainer component={Paper}>
        <Table sx={{minWidth: 650}} aria-label="Provinces Table">
          <TableHead>
            <TableRow>
              <TableCell colSpan={totalColumns - 1}>Provinces</TableCell>
              <TableCell align="right">
                <Button
                  onClick={() => {
                    setIsOpen(true);
                  }}
                  disableElevation
                  variant="contained"
                  endIcon={<AddIcon />}
                >
                  Add
                </Button>
              </TableCell>
            </TableRow>
            <TableRow>
              <TableCell>ID</TableCell>
              <TableCell align="center">Name</TableCell>
              <TableCell align="center">Country</TableCell>
              <TableCell align="center">Actions</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {isSuccess &&
              Boolean(data?.length) &&
              data.map(row => (
                <TableRow key={row._id} sx={{'&:last-child td, &:last-child th': {border: 0}}}>
                  <TableCell component="th" scope="row">
                    {row._id}
                  </TableCell>
                  <TableCell align="center">{row.name}</TableCell>
                  <TableCell align="center">
                    <Box
                      component="img"
                      sx={{width: 40, height: 40, objectFit: 'contain'}}
                      src={getImageURL(row.country.flag)}
                      alt={row.name}
                    />
                  </TableCell>

                  <TableCell align="center">
                    <ProvinceEditIconButton province={row} />
                    <ProvinceDeleteIconButton provinceId={row._id} />
                  </TableCell>
                </TableRow>
              ))}
            {Boolean(isSuccess && !data?.length) && (
              <TableRow>
                <TableCell colSpan={totalColumns}>No Province found</TableCell>
              </TableRow>
            )}
            {isError && (
              <TableRow>
                <TableCell colSpan={totalColumns}>
                  <Typography color="error">Failed to fetch Provinces.</Typography>
                </TableCell>
              </TableRow>
            )}
            {isLoading && (
              <TableRow>
                {Array.from(Array(totalColumns).keys()).map(key => (
                  <TableCell key={key}>
                    <Skeleton variant="text" />
                  </TableCell>
                ))}
              </TableRow>
            )}
          </TableBody>
          <TableFooter>
            <TableRow>
              <TablePagination
                count={100}
                page={0}
                onPageChange={() => {
                  // console.log('onPageChange', rest);
                }}
                rowsPerPage={10}
              />
            </TableRow>
          </TableFooter>
        </Table>
      </TableContainer>
    </>
  );
}

export default ProvincesTable;
